import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "tree-container"
};
const _hoisted_2 = {
  class: "custom-tree-node"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["title"];
const _hoisted_5 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tree = _resolveComponent("el-tree");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    title: "选择收藏夹",
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.show = $event),
    width: "300px",
    "custom-class": "fav-dialog"
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
      onClick: $setup.close
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("取 消", -1)]))]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $setup.confirmHandler
    }, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("确 定", -1)]))]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_tree, {
      data: _ctx.favData,
      class: "tree",
      ref: "elTreee",
      props: $setup.defaultProps,
      "highlight-current": true
    }, {
      default: _withCtx(({
        node
      }) => [_createElementVNode("span", _hoisted_2, [_createElementVNode("img", {
        src: require('@/assets/icons/NavTree/file-icon.svg'),
        alt: "",
        class: "icon"
      }, null, 8, _hoisted_3), _createElementVNode("span", {
        title: node.label
      }, _toDisplayString(node.label), 9, _hoisted_4)])]),
      _: 1
    }, 8, ["data", "props"])])]),
    _: 1
  }, 8, ["modelValue"]);
}